import { Grid, Box } from '@mui/material';
import pakistan from '../../Assets/AlertIcon/pakWithKashmir.svg';
import newGif from '../../Assets/ProfileImage/newGifT.gif';
import Sketcher from './sketcher.component';
import { useAtomValue, useSetAtom } from 'jotai';
import { backGroundColorMainScreen, openSketcher } from '../../common/atom/atoms';
import { IconButton, Tooltip } from '@mui/material';
import PaletteIcon from '@mui/icons-material/Palette';
import { NetworkMonitoringSection } from './network_monitoring_section_component';
import { hasNetworkMonitoringPermissions } from '../../common/functions/permission_utils.function';
export const RightMapSectionLandingPage = () => {
  const setModal = useSetAtom(openSketcher);

  const bg = useAtomValue(backGroundColorMainScreen);

  // Get user permissions
  const permissionsJSON = localStorage.getItem('permissions');
  let permissions = [];
  try {
    permissions = JSON.parse(permissionsJSON) || [];
  } catch (error) {
    console.error('Failed to parse permissions:', error);
  }
  const permissionNames = Array.isArray(permissions)
    ? permissions.map((permission) => permission.name)
    : [];

  // Check if user has any network monitoring permissions
  const hasNetworkPermissions = hasNetworkMonitoringPermissions(permissionNames);

  return (
    <>
      <Grid
        item
        xs={12}
        md={8}
        lg={8}
        sx={{ position: 'relative', background: 'black', pb: '10px', pr: '8px' }}
      >
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            height: '100%',
            background: 'black',
            marginRight: '10%',
            borderRadius: '42px',
          }}
        >
          <IconButton
            onClick={() => setModal(true)}
            sx={{
              position: 'absolute',
              top: 16,
              right: 16,
              bgcolor: '#fff',
              // color: '#BD1D23',
              // border: '1px solid #BD1D23',
              '&:hover': {
                // bgcolor: '#BD1D23',
                color: '#fff',
              },
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            }}
          >
            <Tooltip title="Change Background Color">
              <PaletteIcon />
            </Tooltip>
          </IconButton>
          <Sketcher />
          <Box
            component="img"
            src={newGif}
            alt="Pakistan Map"
            sx={{
              position: 'absolute',
              width: '100%',
              height: '100%',
              borderRadius: '15px',
              // objectFit: 'contain',
              top: 0,
              left: 0,
              zIndex: 1,
              pointerEvents: 'none',
            }}
          />
          {hasNetworkPermissions && <NetworkMonitoringSection />}
        </Box>
      </Grid>
    </>
  );
};
